import { POSITION_COLOR } from "@constants/postion-color";

import { PositionType } from "@type/HRM/position";
import { PostType } from "@type/HRM/post-type";

export const getPositionColor = (
  postType: PostType,
  position: PositionType
) => {
  const currentPostType = postType.find(
    (post: any) => post.id === position.postType
  );
  const currentPostTypeTextColor = currentPostType
    ? currentPostType.nameEn.toUpperCase().replaceAll(" ", "_")
    : "DEFAULT";

  const textColor = POSITION_COLOR[currentPostTypeTextColor] || "DEFAULT";

  return textColor;
};
